import UserService from '@/services/user.js'
import SetupService from '@/services/setup.js'
import CostCenterService from '@/services/cost-center.js'
import ProviderService from '@/services/provider.js'
import ClientService from '@/services/client.js'

export default {
  domain_user_email: {
    messages: {
      en: (field) => `Este campo só aceita emails do domínio @thepes.com.br`,
      pt_BR: (field) => `Este campo só aceita emails do domínio @thepes.com.br`
    },
    validate: (value) => new Promise(resolve => {
      const regex = /[\w0-9.-]*@thepes\.com\.br/g
      return resolve({valid: !!(value.match(regex))})
    })
  },
  unique_user_username: {
    messages: {
      en: (field) => `Este username já está vinculado a um usuário`,
      pt_BR: (field) => `Este username já está vinculado a um usuário`
    },
    validate: (value, defaultValue) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      if (defaultValue && defaultValue[0] && value === defaultValue[0]) {
        return resolve({valid: true})
      } else {
        UserService.checkUsernameExists(value)
        .then(response => {
          return resolve({valid: !(response.body.exists)})
        })
      }
    })
  },
  unique_user_email: {
    messages: {
      en: (field) => `Este email já está vinculado a um usuário`,
      pt_BR: (field) => `Este email já está vinculado a um usuário`
    },
    validate: (value, defaultValue) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      if (defaultValue && defaultValue[0] && value === defaultValue[0]) {
        return resolve({valid: true})
      } else {
        UserService.checkEmailExists(value)
        .then(response => {
          return resolve({valid: !(response.body.exists)})
        })
      }
    })
  },
  existing_email: {
    messages: {
      en: (field) => `Este email não está cadastrado`,
      pt_BR: (field) => `Este email não está cadastrado`
    },
    validate: (value) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      UserService.checkEmailExists(value)
      .then(response => {
        return resolve({valid: (response.body.exists)})
      })
    })
  },
  unique_setup_key: {
    messages: {
      en: (field) => `Este identificador já está vinculado a um registro`,
      pt_BR: (field) => `Este identificador já está vinculado a um registro`
    },
    validate: (value) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      SetupService.checkKeyExists(value)
      .then(response => {
        return resolve({valid: !(response.body.exists)})
      })
    })
  },
  unique_costcenter_code: {
    messages: {
      en: (field) => `Este código já está vinculado a um registro`,
      pt_BR: (field) => `Este código já está vinculado a um registro`
    },
    validate: (value, defaultValue) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      if (defaultValue && defaultValue[0] && value === defaultValue[0]) {
        return resolve({valid: true})
      } else {
        CostCenterService.checkCodeExists(value)
        .then(response => {
          return resolve({valid: !(response.body.exists)})
        })
      }
    })
  },
  unique_client_cnpj: {
    messages: {
      en: (field) => `Este CNPJ já está vinculado a um registro`,
      pt_BR: (field) => `Este CNPJ já está vinculado a um registro`
    },
    validate: (value, defaultValue) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      if (defaultValue && defaultValue[0] && value === defaultValue[0]) {
        return resolve({valid: true})
      } else {
        ClientService.checkCnpjExists(value)
        .then(response => {
          return resolve({valid: !(response.body.exists)})
        })
      }
    })
  },
  unique_provider_cnpj: {
    messages: {
      en: (field) => `Este CNPJ já está vinculado a um registro`,
      pt_BR: (field) => `Este CNPJ já está vinculado a um registro`
    },
    validate: (value, defaultValue) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      if (defaultValue && defaultValue[0] && value === defaultValue[0]) {
        return resolve({valid: true})
      } else {
        ProviderService.checkCnpjExists(value)
        .then(response => {
          return resolve({valid: !(response.body.exists)})
        })
      }
    })
  },
  unique_provider_cpf: {
    messages: {
      en: (field) => `Este CPF já está vinculado a um registro`,
      pt_BR: (field) => `Este CPF já está vinculado a um registro`
    },
    validate: (value, defaultValue) => new Promise(resolve => {
      if (!value) return resolve({valid: false})
      if (defaultValue && defaultValue[0] && value === defaultValue[0]) {
        return resolve({valid: true})
      } else {
        ProviderService.checkCpfExists(value)
        .then(response => {
          return resolve({valid: !(response.body.exists)})
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/validators.js